// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section {
  color: #ffffff;
  /* background-image: url("./../../ASSETS/BACKGROUND/NoiseBgTall.webp"); */
  background-size: cover;
  background-color: #425151;
  /* padding-top: 20px !important; */
  
}
.contact-section .row {
  margin-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/CONTACT/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,yEAAyE;EACzE,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;;AAEpC;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".contact-section {\n  color: #ffffff;\n  /* background-image: url(\"./../../ASSETS/BACKGROUND/NoiseBgTall.webp\"); */\n  background-size: cover;\n  background-color: #425151;\n  /* padding-top: 20px !important; */\n  \n}\n.contact-section .row {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
